import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { RejectType, StateService, Transition, TransitionService, UrlService } from '@uirouter/core';

import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';
import { LocalStorage } from 'services/storage/local';
import { LoggerService } from './http/logger';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class XmErrorHandler implements ErrorHandler {
    private state: StateService;
    private route: UrlService;
    private config: IXMOptions;
    private localStorage: LocalStorage;
    private transition: TransitionService;
    private transitionErrorFrom: string;
    private transitionErrorTo: string;
    private logger: LoggerService;

    constructor(state: StateService, route: UrlService, localStorage: LocalStorage, @Inject(CONFIG_TOKEN) config: IXMOptions, transition: TransitionService, logger: LoggerService) {
        Object.assign(this, { state, route, localStorage, config, transition, logger });

        this.transition.onStart({ from: 'error' }, () => {
            this.transitionErrorFrom = undefined;
            this.transitionErrorTo = undefined;
        });

        this.transition.onError({}, (trans: Transition) => {
            if (trans.error().type === RejectType.ERROR) {
                this.transitionErrorFrom = trans.from().name || 'app_load';
                this.transitionErrorTo = trans.to().name;
            }
        });
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
    /* eslint-disable no-console */
    public handleError(error: any): void {
        if (error.stack && (error.stack.includes('assets.adobedtm.com') || error.stack.includes('satelliteLib') || error.stack.search(/giggy.*.js/) >= 0)) {
            return;
        }

        const stateName: string = this.state.current.name;

        // to prevent an infinite loop
        if (this.route.url().includes('error')) {
            return;
        }

        // do not redirect if the app is running locally
        if (this.config.BASE_URL !== '/') {
            // Log the console error into Kibana
            const data: HttpErrorResponse = {
                ...error,
                name: error?.name ? JSON.parse(JSON.stringify(error.name)) : 'Console Error',
                message: error?.message ? JSON.parse(JSON.stringify(error.message)) : stateName
            };
            this.logger.scriptError(data);

            if (stateName === 'shop.device' || stateName === 'shop.accessory') {
                this.state.go('product-downtime');

                return;
            }

            // Redirect to websheet error page for websheet activation issues
            if (this.route.url().includes('watches/activate') || this.route.url().includes('esim/activate')) {
                this.state.go('watch.activate.error');

                return;
            }

            // Redirect to activation error page for activation issues
            if (this.route.url().includes('activate')) {
                this.state.go('activation-error');

                return;
            }

            if (!this.localStorage.hasKey('xm-error')) {
                this.localStorage.set('xm-error', JSON.stringify(error.stack || error));
            }

            const reason: string = this.transitionErrorFrom ? `${this.transitionErrorFrom}-${this.transitionErrorTo}` : stateName;
            if (window.location.href.includes('now')) {
                const url: string = `${window.location.protocol}//${window.location.host}${this.config.BASE_URL}now-error?reason=${reason}`;
                window.location.href = url;
            } else {
                const url: string = `${window.location.protocol}//${window.location.host}${this.config.BASE_URL}error?reason=${reason}`;
                window.location.href = url;
            }
        } else {
            const data: HttpErrorResponse = {
                ...error,
                name: error.name ? JSON.parse(JSON.stringify(error.name)): 'Console Error',
                message: error.message ? JSON.parse(JSON.stringify(error.message)): ''
            };
            this.logger.scriptError(data);
            console.error(error);
        }
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */
    /* eslint-enable @typescript-eslint/explicit-module-boundary-types */
    /* eslint-enable no-console */
}
